import React, { useCallback, useState } from "react";
import BrandCard from "@components/card/BrandCard";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { BrandFilter } from "@pages/search/_components/index";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { useApiRequest } from "@utils/ApiRequest";
import useAxios from "@libs/axios/useAxios";
import { BRAND_URL } from "@libs/apiUrl";
import { LOAD_SIZE_10 } from "@libs/reactQuery/queryClient";
import useIntersection from "@hook/useIntersection";
import { enFilter, koreanFilter } from "@constants/Constants";
import SearchInput from "@components/input/SearchInput";
import BackHeader from "@components/header/BackHeader";
import { Flex } from "antd";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "2rem",
  padding: "0 2rem",
});

const BrandList = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "2rem",
});

const BrandTab = () => {
  const { getBrandSortList } = useApiRequest();
  const { data: brandSortList, isLoading: brandSortLoading } = useQuery({
    queryKey: ["brandSortList"],
    queryFn: getBrandSortList,
  });

  const [selectedFilter, setSelectedFilter] = useState("ABC 순");
  const [selectedFilterDetail, setSelectedFilterDetail] = useState("ALL");

  const { axiosInstance } = useAxios();

  const getBrandList = useCallback(
    async ({ pageParam = 1 }) => {
      let url =
        selectedFilterDetail === "ALL"
          ? `${BRAND_URL}?page=${pageParam}&limit=${LOAD_SIZE_10}&order_by=${selectedFilter === "가나다 순" ? "KOREAN_ASC" : selectedFilter === "ABC 순" ? "ALPHABET_ASC" : "DATE_DESC"}`
          : `${BRAND_URL}?page=${pageParam}&limit=${LOAD_SIZE_10}&order_by=${selectedFilter === "가나다 순" ? "KOREAN_ASC" : selectedFilter === "ABC 순" ? "ALPHABET_ASC" : "DATE_DESC"}&start_with=${selectedFilterDetail}`;

      const res = await axiosInstance.get(url);
      if (res.status === 200) {
        return res.data;
      }
    },
    [axiosInstance, selectedFilter, selectedFilterDetail],
  );

  const {
    data: brandList,
    fetchNextPage,
    isLoading,
  } = useInfiniteQuery({
    queryKey: ["brandList", selectedFilter, selectedFilterDetail],
    queryFn: ({ pageParam = 1 }) => getBrandList({ pageParam }),
    initialPageParam: 1,
    getNextPageParam: (lastPages, pages) =>
      pages?.length < lastPages.data.total_count / LOAD_SIZE_10
        ? pages.length + 1
        : undefined,
  });

  const { setObserverTarget } = useIntersection(() => {
    fetchNextPage();
  });

  return brandSortLoading || isLoading ? null : (
    <Container>
      <BrandFilter
        filterList={brandSortList}
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
        selectedFilterList={
          selectedFilter === brandSortList[0].name_ko ? enFilter : koreanFilter
        }
        selectedFilterDetail={selectedFilterDetail}
        setSelectedFilterDetail={setSelectedFilterDetail}
      />

      <BrandList>
        {brandList?.pages?.map((page) => {
          return page?.data?.list?.map((item: any) => (
            <BrandCard
              id={item.brand_id}
              name={item.brand_name_en}
              koreanName={item.brand_name_ko}
              src={item.logo_url}
              liked={item.is_liked === 0 ? false : true}
              withImage
              imageList={item.image_list}
            />
          ));
        })}
      </BrandList>

      <div ref={setObserverTarget} />
    </Container>
  );
};

export default BrandTab;
